import React from 'react';

export const appointmentLanguageContent = {
    'appointment': {
        'en': 'Appointment',
        'ar': 'ميعاد',
        'ht': 'Randevou',
        'pl': 'Spotkanie',
        'pt': 'Encontro',
        'sr': 'Именовање',
        'es': 'Cita',
        'vi': 'Cuộc hẹn',
        'zh': '预约',
        'ne': 'नियुक्ति'
    },
    'appt-1': {
        'en': <p className='font-normal text-sm items-start text-[#333] text-center break-words mt-2'>We need to gather and complete a few items to <b className='font-semibold'>pre-register</b> for the upcoming event.</p>,
        'ar': <p className='font-normal text-sm items-start text-[#333] break-words mt-2 dir-rtl'>نحن بحاجة إلى جمع وإكمال بعض العناصر <b className='font-semibold'>للتسجيل المسبق</b> للحدث القادم.</p>,
        'ht': <p className='font-normal text-sm items-start text-[#333] text-center break-words mt-2'>Nou bezwen rasanble epi ranpli kèk atik pou nou <b className='font-semibold'>enskri davans</b> pou evènman k ap vini an.</p>,
        'pl': <p className='font-normal text-sm items-start text-[#333] text-center break-words mt-2'>Musimy zebrać i skompletować kilka elementów, aby <b className='font-semibold'>wstępnie zarejestrować się</b> na nadchodzące wydarzenie.</p>,
        'pt': <p className='font-normal text-sm items-start text-[#333] text-center break-words mt-2'>Precisamos reunir e preencher alguns itens para <b className='font-semibold'>pré-inscrever-se</b> para o próximo evento.</p>,
        'sr': <p className='font-normal text-sm items-start text-[#333] text-center break-words mt-2'>Морамо да прикупимо и довршимо неколико ставки за <b className='font-semibold'>претходно регистровање</b> за предстојећи догађај.</p>,
        'es': <p className='font-normal text-sm items-start text-[#333] text-center break-words mt-2'>Necesitamos reunir y completar algunos elementos para <b className='font-semibold'>preinscribirnos</b> para el próximo evento.</p>,
        'vi': <p className='font-normal text-sm items-start text-[#333] text-center break-words mt-2'>Chúng ta cần thu thập và hoàn thiện một số hạng mục để <b className='font-semibold'>đăng ký trước</b> cho sự kiện sắp tới.</p>,
        'zh': <p className='font-normal text-sm items-start text-[#333] text-center break-words mt-2'>我们需要收集并完成一些项目，以便为即将举行的活动<b className='font-semibold'>预注册</b>。</p>,
        'ne': <p className='font-normal text-sm items-start text-[#333] text-center break-words mt-2'>हामीले आगामी कार्यक्रमको लागि <b className='font-semibold'>पूर्व-दर्ता गर्न</b> केही वस्तुहरू सङ्कलन र पूरा गर्न आवश्यक छ।</p>
    },
    'appt-2': {
        'en': <>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px] text-justify appt-text'>
                To complete pre-registration requirements press the <b className='text-[#64A003]'>Begin</b> button below.</p>
            <p data-testid="para-2" className='font-normal text-[14px] text-justify appt-text'>
                To Change, Cancel or choose different options regarding your upcoming appointment, press the <b className='text-primary'>Options</b> button below.</p>
        </>,
        'ar': <span className='dir-rtl'>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px]'>
                لإكمال متطلبات التسجيل المسبق، اضغط على الزر <b className='text-[#64A003]'>ابدأ</b> أدناه.</p>
            <p data-testid="para-2" className='font-normal text-[14px]'>
                لتغيير أو إلغاء أو اختيار خيارات مختلفة بخصوص موعدك القادم، اضغط على زر <b className='text-primary'>الخيارات</b> أدناه.</p>
        </span>,
        'ht': <>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px] text-justify appt-text'>
                Pou ranpli kondisyon pre-enskripsyon, peze bouton <b className='text-[#64A003]'>Kòmanse</b> ki anba a.</p>
            <p data-testid="para-2" className='font-normal text-[14px] text-justify appt-text'>
                Pou Chanje, Anile oswa chwazi diferan opsyon konsènan randevou w ap vini, peze bouton <b className='text-primary'>Opsyon</b> ki anba a.</p>
        </>,
        'pl': <>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px] text-justify appt-text'>
                Aby spełnić wymagania dotyczące rejestracji wstępnej, naciśnij przycisk <b className='text-[#64A003]'>Rozpocznij</b> poniżej.</p>
            <p data-testid="para-2" className='font-normal text-[14px] text-justify appt-text'>
                Aby zmienić, anulować lub wybrać inne opcje dotyczące nadchodzącego spotkania, naciśnij przycisk <b className='text-primary'>Opcje</b> poniżej.</p>
        </>,
        'pt': <>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px] text-justify appt-text'>
                Para completar os requisitos de pré-registro, pressione o botão <b className='text-[#64A003]'>Iniciar</b> abaixo.</p>
            <p data-testid="para-2" className='font-normal text-[14px] text-justify appt-text'>
                Para alterar, cancelar ou escolher opções diferentes em relação ao seu próximo compromisso, pressione o botão <b className='text-primary'>Opções</b> abaixo.</p>
        </>,
        'sr': <>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px] text-justify appt-text'>
                Да бисте испунили услове за регистрацију унапред, притисните дугме <b className='text-[#64A003]'>Почетак</b> у наставку.</p>
            <p data-testid="para-2" className='font-normal text-[14px] text-justify appt-text'>
                Да бисте променили, отказали или изабрали различите опције у вези са предстојећим састанком, притисните дугме <b className='text-primary'>Опције</b> у наставку.</p>
        </>,
        'es': <>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px] text-justify appt-text'>
                Para completar los requisitos de preinscripción, presione el botón <b className='text-[#64A003]'>Comenzar</b> a continuación.</p>
            <p data-testid="para-2" className='font-normal text-[14px] text-justify appt-text'>
                Para cambiar, cancelar o elegir diferentes opciones con respecto a su próxima cita, presione el botón <b className='text-primary'>Opciones</b> a continuación.</p>
        </>,
        'vi': <>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px] text-justify appt-text'>
                Để hoàn tất các yêu cầu đăng ký trước, hãy nhấn nút <b className='text-[#64A003]'>Bắt đầu</b> bên dưới.</p>
            <p data-testid="para-2" className='font-normal text-[14px] text-justify appt-text'>
                Để Thay đổi, Hủy hoặc chọn các tùy chọn khác nhau liên quan đến cuộc hẹn sắp tới của bạn, hãy nhấn nút <b className='text-primary'>Tùy chọn</b> bên dưới.</p>
        </>,
        'zh': <>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px] text-justify appt-text'>
                要完成预注册要求，请按下面的<b>开始</b>按钮。</p>
            <p data-testid="para-2" className='font-normal text-[14px] text-justify appt-text'>
                要更改、取消或选择有关即将到来的约会的不同选项，请按下面的<b className='text-[#64A003]'>选项</b>按钮。</p>
        </>,
        'ne': <>
            <p data-testid="para-1" className='my-[20px] font-normal text-[14px] text-justify appt-text'>
                पूर्व-दर्ता आवश्यकताहरू पूरा गर्न तलको <b className='text-[#64A003]'>सुरु गर्नुहोस्</b> बटन थिच्नुहोस्।</p>
            <p data-testid="para-2" className='font-normal text-[14px] text-justify appt-text'>
                तपाईंको आगामी भेटघाटको सन्दर्भमा विभिन्न विकल्पहरू परिवर्तन गर्न, रद्द गर्न वा छनौट गर्न तलको <b className='text-primary'>विकल्पहरू</b> बटन थिच्नुहोस्।</p>
        </>
    },
    'appt-3': {
        'en': 'What would you like to do for this Appointment?',
        'ar': 'ماذا تريد أن تفعل لهذا الموعد؟',
        'ht': 'Kisa ou ta renmen fè pou randevou sa a?',
        'pl': 'Co chciałbyś zrobić w związku z tym spotkaniem?',
        'pt': 'O que você gostaria de fazer nesta consulta?',
        'sr': 'Шта бисте желели да урадите за овај састанак?',
        'es': '¿Qué le gustaría hacer para esta cita?',
        'vi': 'Bạn muốn làm gì cho Cuộc hẹn này?',
        'zh': '您想为这次约会做什么？',
        'ne': 'तपाईं यो नियुक्तिको लागि के गर्न चाहनुहुन्छ?'
    },
    'appt-4': {
        'en': 'Select from any other upcoming appointment below to change them.',
        'ar': 'اختر من أي موعد قادم آخر أدناه لتغييره.',
        'ht': 'Chwazi nan nenpòt lòt randevou k ap vini pi ba a pou chanje yo.',
        'pl': 'Wybierz poniżej dowolne inne nadchodzące spotkanie, aby je zmienić.',
        'pt': 'Selecione qualquer outro compromisso futuro abaixo para alterá-los.',
        'sr': 'Изаберите неки други предстојећи састанак у наставку да бисте их променили.',
        'es': 'Seleccione entre cualquier otra cita próxima a continuación para cambiarla.',
        'vi': 'Chọn từ bất kỳ cuộc hẹn sắp tới nào khác bên dưới để thay đổi chúng.',
        'zh': '从下面任何其他即将到来的约会中进行选择以进行更改。',
        'ne': 'तिनीहरूलाई परिवर्तन गर्न तलको कुनै पनि आगामी भेटघाटबाट चयन गर्नुहोस्।'
    },
    'cancel': {
        'en': 'Cancel',
        'ar': 'يلغي',
        'ht': 'Anile',
        'pl': 'Anulować',
        'pt': 'Cancelar',
        'sr': 'Поништити, отказати',
        'es': 'Cancelar',
        'vi': 'Hủy bỏ',
        'zh': '取消',
        'ne': 'रद्द गर्नुहोस्'
    },
    'reschedule': {
        'en': 'Reschedule',
        'ar': 'إعادة جدولة',
        'ht': 'Repwograme',
        'pl': 'Zmień termin',
        'pt': 'Reprogramar',
        'sr': 'Ресцхедуле',
        'es': 'Reprogramar',
        'vi': 'Sắp xếp lại',
        'zh': '改期',
        'ne': 'पुन: तालिका'
    },
    'confirm': {
        'en': 'Confirm',
        'ar':  'يتأكد',
        'ht': 'Konfime',
        'pl': 'Potwierdzać',
        'pt': 'confirme',
        'sr': 'Потврди',
        'es': 'Confirmar',
        'vi': 'Xác nhận',
        'zh': '确认',
        'ne': 'पुष्टि गर्नुहोस्'
    },
    'reschedule-1': {
        'en': 'Please select an appointment option from the dropdown below.',
        'ar':  'يرجى تحديد خيار الموعد من القائمة المنسدلة أدناه.',
        'ht': 'Tanpri chwazi yon opsyon randevou nan deroule ki anba a.',
        'pl': 'Proszę wybrać opcję spotkania z poniższego menu.',
        'pt': 'Selecione uma opção de agendamento no menu suspenso abaixo.',
        'sr': 'Молимо изаберите опцију заказивања са падајућег менија у наставку.',
        'es': 'Seleccione una opción de cita del menú desplegable a continuación.',
        'vi': 'Vui lòng chọn một tùy chọn cuộc hẹn từ danh sách thả xuống bên dưới.',
        'zh': '请从下面的下拉列表中选择一个预约选项。',
        'ne': 'कृपया तलको ड्रपडाउनबाट अपोइन्टमेन्ट विकल्प चयन गर्नुहोस्।'
    },
    'reschedule-2': {
        'en': <p className='font-normal text-sm text-[#333] text-justify justify-center break-words md:text-center lg:text-center xl:text-center'>
            I prefer my <b className='text-primary font-semibold'>appointment</b> to take place:
        </p>,
        'ar':  <p className='font-normal text-sm text-[#333] dir-rtl justify-center break-words'>
            أفضل أن يتم <b className='text-primary font-semibold'>موعدي</b>:
        </p>,
        'ht': <p className='font-normal text-sm text-[#333] text-justify justify-center break-words md:text-center lg:text-center xl:text-center'>
            Mwen prefere <b className='text-primary font-semibold'>randevou mwen</b> pran plas:
        </p>,
        'pl': <p className='font-normal text-sm text-[#333] text-justify justify-center break-words md:text-center lg:text-center xl:text-center'>
            Wolę, aby moja <b className='text-primary font-semibold'>wizyta</b> odbyła się:
        </p>,
        'pt': <p className='font-normal text-sm text-[#333] text-justify justify-center break-words md:text-center lg:text-center xl:text-center'>
            Prefiro que meu <b className='text-primary font-semibold'>compromisso</b> aconteça:
        </p>,
        'sr': <p className='font-normal text-sm text-[#333] text-justify justify-center break-words md:text-center lg:text-center xl:text-center'>
            Више волим да се мој <b className='text-primary font-semibold'>састанак</b> одржи:
        </p>,
        'es': <p className='font-normal text-sm text-[#333] text-justify justify-center break-words md:text-center lg:text-center xl:text-center'>
            Prefiero que mi <b className='text-primary font-semibold'>cita</b> se realice:
        </p>,
        'vi': <p className='font-normal text-sm text-[#333] text-justify justify-center break-words md:text-center lg:text-center xl:text-center'>
            Tôi muốn <b className='text-primary font-semibold'>cuộc hẹn</b> của mình diễn ra:
        </p>,
        'zh': <p className='font-normal text-sm text-[#333] text-justify justify-center break-words md:text-center lg:text-center xl:text-center'>
            我希望我的<b className='text-primary font-semibold'>预约</b>能够进行：
        </p>,
        'ne': <p className='font-normal text-sm text-[#333] text-justify justify-center break-words md:text-center lg:text-center xl:text-center'>
            म मेरो <b>अपोइन्टमेन्ट</b> गर्न चाहन्छु:
        </p>
    },
    'mornings': {
        'en': 'Mornings',
        'ar':  'الصباح',
        'ht': 'Maten',
        'pl': 'Poranki',
        'pt': 'Manhãs',
        'sr': 'јутра',
        'es': 'mañanas',
        'vi': 'Buổi sáng',
        'zh': '早晨',
        'ne': 'बिहान'
    },
    'evenings': {
        'en': 'Evenings',
        'ar':  'الأمسيات',
        'ht': 'Swè',
        'pl': 'Wieczory',
        'pt': 'Noites',
        'sr': 'Вечери',
        'es': 'Tardes',
        'vi': 'Buổi tối',
        'zh': '晚上',
        'ne': 'साँझ'
    },
    'sometime-in-the-next-week': {
        'en': 'Sometime in the next week',
        'ar':  'في وقت ما في الأسبوع المقبل',
        'ht': 'Yon lè nan semèn kap vini an',
        'pl': 'Gdzieś w następnym tygodniu',
        'pt': 'Em algum momento na próxima semana',
        'sr': 'Негде следеће недеље',
        'es': 'En algún momento de la próxima semana',
        'vi': 'Vào lúc nào đó trong tuần tới',
        'zh': '下周的某个时候',
        'ne': 'अर्को हप्तामा कहिले काँही'
    },
    'sometime-in-the-next-month': {
        'en': 'Sometime in the next month',
        'ar':  'في وقت ما في الشهر المقبل',
        'ht': 'Yon lè nan mwa kap vini an',
        'pl': 'Gdzieś w następnym miesiącu',
        'pt': 'Em algum momento no próximo mês',
        'sr': 'Негде у наредних месец дана',
        'es': 'En algún momento del próximo mes',
        'vi': 'Vào lúc nào đó trong tháng tới',
        'zh': '下个月的某个时候',
        'ne': 'अर्को महिनामा कुनै समय'
    },
    'soonest-available': {
        'en': 'Soonest available',
        'ar':  'أقرب وقت متاح',
        'ht': 'Pi vit disponib',
        'pl': 'Najszybciej dostępne',
        'pt': 'Disponível em breve',
        'sr': 'Најскорије доступно',
        'es': 'Lo más pronto disponible',
        'vi': 'Có sẵn sớm nhất',
        'zh': '最快可用',
        'ne': 'चाँडै उपलब्ध'
    },
    'choose-an-option': {
        'en': 'Choose an option',
        'ar':  'إختر خيار',
        'ht': 'Chwazi yon opsyon',
        'pl': 'Wybierz opcję',
        'pt': 'Escolha uma opção',
        'sr': 'Изабери опцију',
        'es': 'Elige una opcion',
        'vi': 'Chọn một sự lựa chọn',
        'zh': '选择一个选项',
        'ne': 'एउटा विकल्प छान्नुहोस्'
    },
    'cancel-text': {
        'en': <>
            <p className='font-normal text-sm items-start text-[#333] text-justify break-words mt-[18px]'>
                <b>Warning</b>. If you cancel your appointment you will lose your timeslot. If you would like to Change your Appointment instead, press the <b className='text-primary'>Back</b> button and select a different option.</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px] text-center'>Please list a reason below</p>
        </>,
        'ar':  <div className='dir-rtl'>
            <p className='font-normal text-sm items-start text-[#333] break-words mt-[18px]'>
                <b>تحذير</b>. إذا قمت بإلغاء موعدك فسوف تفقد الفترة الزمنية الخاصة بك. إذا كنت ترغب في تغيير موعدك بدلاً من ذلك، فاضغط على الزر <b className='text-primary'>رجوع</b> وحدد خيارًا مختلفًا.</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px]'>يُرجى ذكر السبب أدناه</p></div>,
        'ht': <>
            <p className='font-normal text-sm items-start text-[#333] text-justify break-words mt-[18px]'>
                <b>Avètisman</b>. Si w anile randevou w, w ap pèdi tan w. Si ou ta renmen chanje randevou ou pito, peze bouton <b className='text-primary'>Retounen</b> epi chwazi yon lòt opsyon.</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px] text-center'>Tanpri mete yon rezon anba a</p></>,
        'pl': <>
            <p className='font-normal text-sm items-start text-[#333] text-justify break-words mt-[18px]'>
                <b>Ostrzeżenie</b>. Jeśli odwołasz wizytę, utracisz zarezerwowany termin. Jeśli zamiast tego chcesz zmienić termin, naciśnij przycisk <b className='text-primary'>Wstecz</b> i wybierz inną opcję.</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px] text-center'>Podaj powód poniżej</p></>,
        'pt': <>
            <p className='font-normal text-sm items-start text-[#333] text-justify break-words mt-[18px]'>
                <b>Aviso</b>. Se você cancelar seu agendamento, perderá seu horário. Se desejar alterar seu compromisso, pressione o botão <b className='text-primary'>Voltar</b> e selecione uma opção diferente.</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px] text-center'>Liste um motivo abaixo</p></>,
        'sr': <>
            <p className='font-normal text-sm items-start text-[#333] text-justify break-words mt-[18px]'>
                <b>Упозорење</b>. Ако откажете свој термин, изгубићете свој термин. Ако уместо тога желите да промените термин, притисните дугме <b className='text-primary'>Назад</b> и изаберите другу опцију.</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px] text-center'>Наведите разлог у наставку</p>
        </>,
        'es': <>
            <p className='font-normal text-sm items-start text-[#333] text-justify break-words mt-[18px]'>
                <b>Advertencia</b>. Si cancelas tu cita perderás tu franja horaria. Si en su lugar desea cambiar su cita, presione el botón <b className='text-primary'>Atrás</b> y seleccione una opción diferente.</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px] text-center'>Indique un motivo a continuación</p>
        </>,
        'vi': <>
            <p className='font-normal text-sm items-start text-[#333] text-justify break-words mt-[18px]'>
                <b>Cảnh báo</b>. Nếu bạn hủy cuộc hẹn, bạn sẽ mất thời gian. Thay vào đó, nếu bạn muốn Thay đổi cuộc hẹn của mình, hãy nhấn nút <b className='text-primary'>Quay lại</b> và chọn một tùy chọn khác.</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px] text-center'>Vui lòng liệt kê lý do bên dưới</p>
        </>,
        'zh': <>
            <p className='font-normal text-sm items-start text-[#333] text-justify break-words mt-[18px]'>
                <b>警告</b>。如果您取消预约，您将失去您的时间段。如果您想更改约会，请按<b className='text-primary'>返回</b>按钮并选择其他选项。</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px] text-center'>请在下面列出原因</p>
        </>,
        'ne': <>
            <p className='font-normal text-sm items-start text-[#333] text-justify break-words mt-[18px]'>
                <b>चेतावनी</b>। यदि तपाईंले आफ्नो अपोइन्टमेन्ट रद्द गर्नुभयो भने तपाईंले आफ्नो समयावधि गुमाउनुहुनेछ। यदि तपाईं यसको सट्टा आफ्नो भेटघाट परिवर्तन गर्न चाहनुहुन्छ भने, <b className='text-primary'>पछाडि</b> बटन थिच्नुहोस् र फरक विकल्प चयन गर्नुहोस्।</p>
            <p className='font-semibold text-sm text-[#333] break-words mt-[20px] text-center'>कृपया तल एउटा कारण सूचीबद्ध गर्नुहोस्</p>
        </>
    },
    'other': {
        'en': 'Other',
        'ar':  'آخر',
        'ht': 'Lòt',
        'pl': 'Inny',
        'pt': 'Outro',
        'sr': 'Остало',
        'es': 'Otro',
        'vi': 'Khác',
        'zh': '其他',
        'ne': 'अन्य'
    },
}